/**
 * @flow
 * @relayHash 46e1aeef0904421c592d8463953fc281
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteLineItemFromCartInput = {|
  lineItemId: string
|};
export type DeleteLineItemFromCartMutationVariables = {|
  input: DeleteLineItemFromCartInput
|};
export type DeleteLineItemFromCartMutationResponse = {|
  +deleteLineItemFromCart: ?{|
    +cart: ?{|
      +additionalProducts: ?$ReadOnlyArray<?{|
        +id: string,
        +price: ?any,
        +type: ?string,
      |}>,
      +lineItems: ?$ReadOnlyArray<?{|
        +id: string,
        +productType: ?string,
        +product: ?{|
          +eventId: ?number,
          +price: ?any,
        |},
        +productParams: ?{|
          +foto?: ?{|
            +sgId: ?number
          |},
          +startnumber?: ?string,
        |},
      |}>,
      +totalPrice: ?any,
    |}
  |}
|};
export type DeleteLineItemFromCartMutation = {|
  variables: DeleteLineItemFromCartMutationVariables,
  response: DeleteLineItemFromCartMutationResponse,
|};
*/


/*
mutation DeleteLineItemFromCartMutation(
  $input: DeleteLineItemFromCartInput!
) {
  deleteLineItemFromCart(input: $input) {
    cart {
      additionalProducts {
        id
        price
        type
      }
      lineItems {
        id
        productType
        product {
          eventId
          price
          id
        }
        productParams {
          __typename
          ... on SingleFotoParams {
            foto {
              sgId
              id
            }
          }
          ... on FotoFlatParams {
            startnumber
          }
        }
      }
      totalPrice
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteLineItemFromCartInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "additionalProducts",
  "storageKey": null,
  "args": null,
  "concreteType": "Product",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "productType",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "eventId",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sgId",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "type": "FotoFlatParams",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "startnumber",
      "args": null,
      "storageKey": null
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalPrice",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteLineItemFromCartMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteLineItemFromCart",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteLineItemFromCartPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cart",
            "storageKey": null,
            "args": null,
            "concreteType": "Cart",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lineItems",
                "storageKey": null,
                "args": null,
                "concreteType": "LineItem",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "product",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Product",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v3/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "productParams",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "type": "SingleFotoParams",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "foto",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Media",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v8/*: any*/)
                    ]
                  }
                ]
              },
              (v9/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteLineItemFromCartMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteLineItemFromCart",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteLineItemFromCartPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cart",
            "storageKey": null,
            "args": null,
            "concreteType": "Cart",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lineItems",
                "storageKey": null,
                "args": null,
                "concreteType": "LineItem",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "product",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Product",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "productParams",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "SingleFotoParams",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "foto",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Media",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v2/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v8/*: any*/)
                    ]
                  }
                ]
              },
              (v9/*: any*/),
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteLineItemFromCartMutation",
    "id": null,
    "text": "mutation DeleteLineItemFromCartMutation(\n  $input: DeleteLineItemFromCartInput!\n) {\n  deleteLineItemFromCart(input: $input) {\n    cart {\n      additionalProducts {\n        id\n        price\n        type\n      }\n      lineItems {\n        id\n        productType\n        product {\n          eventId\n          price\n          id\n        }\n        productParams {\n          __typename\n          ... on SingleFotoParams {\n            foto {\n              sgId\n              id\n            }\n          }\n          ... on FotoFlatParams {\n            startnumber\n          }\n        }\n      }\n      totalPrice\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2fbc653cfa1981240c060f247e739a1d';

module.exports = node;
